
import React, { useState } from "react"
import { useSelector } from "react-redux"
import classes from "./UploadContentBankItem.module.css"
import UploadChooseStep from "./UploadChooseStep.js"
import UploadFormStep from "./UploadFormStep"
import UploadPreviewStep from "./UploadPreviewStep"
import { onKeyDown } from "../../../../../service"
import BackdropPopup from "../../../../lms-shared/UI/Popups/BackdropPopup/BackdropPopup"

const UploadContentBankItem = ({ classification, tabText, listFilter, closeMessage, items, theTabText, setAddItem }) => {
    const texts = useSelector(state => state.translate.texts);
    const [filteredlist, setFilteredList] = useState(items)
    const [uploadStep, setUploadStep] = useState(1)
    const [selectedProject, setSelectedProject] = useState()
    console.log('selectedProject', selectedProject)

    return (
        <>
            <BackdropPopup myWidth={"min-content"} myHeight={"min-content"}>
                <div className={classes.Title}>
                    <div className={classes.TitleText}>{texts.upload} {tabText} {texts.toRepository}</div>
                    <div className={classes.CloseBtn} onClick={() => { closeMessage() }} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => closeMessage())}></div>
                </div>
                {uploadStep == 1 &&
                    <UploadChooseStep
                        setUploadStep={setUploadStep}
                        listFilter={listFilter}
                        filteredlist={filteredlist}
                        items={items}
                        setFilteredList={setFilteredList}
                        selectedProject={selectedProject}
                        setSelectedProject={setSelectedProject}>
                    </UploadChooseStep>
                }
                {
                    uploadStep == 2 && selectedProject &&
                    <UploadFormStep
                        classification={classification}
                        setUploadStep={setUploadStep}
                        selectedProject={selectedProject}
                        setSelectedProject={setSelectedProject}
                        tabText={theTabText}
                        setAddItem={setAddItem}>
                    </UploadFormStep>
                }
                {
                    uploadStep == 3 &&
                    <UploadPreviewStep
                        selectedProject={selectedProject}
                        submit={closeMessage}
                        tabText={theTabText}>
                    </UploadPreviewStep>
                }
            </BackdropPopup>


        </>
    )
}

export default UploadContentBankItem;